import { createFeatureSelector, createSelector } from "@ngrx/store";
import { InitialStateSetting } from "./setting.reducer";

export const selectModalConfirm = createSelector(
  createFeatureSelector('settingState'),
  (settingState: InitialStateSetting) => {
      return settingState.modalConfirm;
  }
)

export const selectAlert = createSelector(
  createFeatureSelector('settingState'),
  (settingState: InitialStateSetting) => {
      return settingState.alert;
  }
)

export const selectSpinner = createSelector(
  createFeatureSelector('settingState'),
  (settingState: InitialStateSetting) => {
      return settingState.spinner;
  }
)

export const selectOpenSidebar = createSelector(
  createFeatureSelector('settingState'),
  (settingState: InitialStateSetting) => {
      return settingState.openSidebar;
  }
)
